import "@total-typescript/ts-reset";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./supabase";
import "@/common/utils/sentry";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
